import { useEffect, useRef } from "react";

export const ADMIN_AUTO_REFRESH_MS = 15000;

export default function useAdminAutoRefresh(callback, { enabled = true, intervalMs = ADMIN_AUTO_REFRESH_MS } = {}) {
  const callbackRef = useRef(callback);
  const runningRef = useRef(false);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") return undefined;

    const run = () => {
      if (document.visibilityState === "hidden" || runningRef.current) return;
      runningRef.current = true;
      Promise.resolve(callbackRef.current?.())
        .catch(() => {})
        .finally(() => {
          runningRef.current = false;
        });
    };
    const runWhenVisible = () => {
      if (document.visibilityState === "visible") run();
    };

    const timer = window.setInterval(run, intervalMs);
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", runWhenVisible);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", runWhenVisible);
    };
  }, [enabled, intervalMs]);
}
